import { Button, Col, Modal, Row, Text } from 'components';
import { Api, theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const SubSettings = ({ visible, handleClose, item, onUnsubscribe }) => {
  const { t } = useTranslation(),
    dispatch = useDispatch();

  function unsubscribe() {
    handleClose();

    setTimeout(async () => {
      const res = await Api.post(
        '/subscriptions/unsubscribe',
        { subscriptionId: item._id },
        'navigator'
      );
      if (!res) return;

      dispatch({
        type: 'UNSUBSCRIBE',
        payload: res
      });

      onUnsubscribe && onUnsubscribe();
    }, 310);
  }

  return (
    <Modal visible={visible} closeModal={handleClose}>
      <Col marg="16px">
        <Text>{t('subscribe.sureToCancel')}</Text>

        <Row marg="16px 0 0" gap="8px">
          <Button text={t('common.cancel')} onClick={handleClose} />

          <Button bg={theme.SECONDARY} text={t('common.unsubscribe')} onClick={unsubscribe} />
        </Row>
      </Col>
    </Modal>
  );
};

export default SubSettings;
